// extracted by mini-css-extract-plugin
export default {"headline":"o_diu1t0FTdv2_tye77B","points":"IEY9cC0BpY_0hW7XCDFz"};